import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {Tooltip} from '@mui/material';
import {string} from 'prop-types';
import React from 'react';
import IconButton from '../IconButton.js';

export const ImageryLink = ({layer, tooltipPlacement = 'bottom'}) => {
  const [itemType, itemId] = layer.split(':');
  let title, href;
  if (itemType === 'Mosaic') {
    title = 'Open in Mosaics';
    href = `https://insights.planet.com/data/mosaics?mosaic=${itemId}`;
  } else {
    title = 'Open in Explorer';
    href = `https://www.planet.com/explorer/?item=${itemType}::${itemId}`;
  }

  return (
    <Tooltip title={title} placement={tooltipPlacement}>
      <IconButton onClick={() => window.open(href)}>
        <OpenInNewIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

ImageryLink.propTypes = {
  tooltipPlacement: string,
  layer: string,
};
